import RewardsHistoryRow from '@/components/rewards_history_row/RewardsHistoryRow.vue';

import { createNamespacedHelpers } from 'vuex';

const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'DashboardRewardsHistory',
  components: { RewardsHistoryRow },
  data: function() {
    return {};
  },
  computed: {
    ...mapConciergeState({
      conciergeRewards: state => state.conciergeRewards
    })
  }
};
